import PropTypes from 'prop-types';
import DeviceSettingsFields from '../vonage/device_settings/DeviceSettingsFields';
import { sharedDeviceMessage } from '../vonage/device_settings/messages';
import LiveCaptionsToggle from '../vonage/live_captions/LiveCaptionsToggle';

const VonageDeviceSettings = ({
  controller,
  hasVideoSource,
  liveCaptions,
  locale,
}) => {
  const t = id => sharedDeviceMessage(id, locale) || '';

  return (
    <div className="vonage-device-settings-panel">
      <DeviceSettingsFields
        controller={controller}
        cameraLocked={!hasVideoSource}
        inSession
        t={t}
      />
      {liveCaptions?.available && (
        <LiveCaptionsToggle
          checked={liveCaptions.isEnabled}
          disabled={liveCaptions.isStarting}
          onChange={liveCaptions.onChange}
          t={t}
        />
      )}
    </div>
  );
};

VonageDeviceSettings.propTypes = {
  controller: PropTypes.object.isRequired,
  hasVideoSource: PropTypes.bool.isRequired,
  liveCaptions: PropTypes.shape({
    available: PropTypes.bool.isRequired,
    isEnabled: PropTypes.bool.isRequired,
    isStarting: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
  }),
  locale: PropTypes.string.isRequired,
};

export default VonageDeviceSettings;
